import React from "react";
import { useHistory } from "react-router-dom";
import { WSPageToolbar } from "@wingspanhq/fe-component-library";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces/api/requirement";
import { RequirementContextType } from "../../../../Requirements/types";
import { useRequirementsConfig } from "../../../../Requirements/useRequirementsConfig";
import {
  PAYEES_ROOT_PATH,
  useGoToPayeeDetailsRequirements
} from "../../../utils";
import { RequirementDetailsContent } from "../../../../Requirements/components/RequirementsDetails/RequirementDetailsContent";
import { Payee } from "@wingspanhq/wingspan-api-sdk";
import { selectorPayeeDisplayName } from "../../../../../shared/selectors/selectorPayeeDisplayName";

type RequirementsDetailsProps = {
  payee: Payee;
  requirement: IRequirementResponse;
};

export const RequirementsDetailsRoute: React.FC<RequirementsDetailsProps> = ({
  payee,
  requirement
}) => {
  const history = useHistory();
  const goToPayeeDetailsRequirements = useGoToPayeeDetailsRequirements();

  const requirementConfig = useRequirementsConfig({
    requirements: [requirement],
    contextType: RequirementContextType.Payee
  });

  const title = requirementConfig.getRequirementName(requirement);

  return (
    <>
      <WSPageToolbar
        actions={requirementConfig.getToolbarActions(requirement)}
        breadcrumbs={[
          {
            label: "Contractors",
            onClick: () => {
              history.push(PAYEES_ROOT_PATH);
            }
          },
          {
            label: selectorPayeeDisplayName(payee),
            onClick: () => {
              goToPayeeDetailsRequirements(payee.id!);
            }
          },
          {
            label: title || "Requirement"
          }
        ]}
      />

      <RequirementDetailsContent
        {...requirementConfig}
        contextType={RequirementContextType.Payee}
        requirement={requirement}
      />
    </>
  );
};
